define(
    'NMSDesignSystem.FeaturedProducts.Shopping',
    [
        'Merchandising.View',
        'Home.View',
        'ItemRelations.RelatedItem.View',
        'Cart.QuickAddToCart.View',
        'Cart.AddToCart.Button.View',
        'NMSDesignSystem.ProductPrice.Shopping',
        'Product.Model',
        'jQuery',
        'underscore',
        'nms_buyflushots_home.tpl',
        'nms_main_home.tpl',
        'nms_facets_item_cell_card.tpl',
        'nms_facets_item_card_action.tpl'
    ],
    function NMSDesignSystemFeaturedProductsShopping(
        MerchandisingView,
        HomeView,
        ItemRelationsRelatedItemView,
        CartQuickAddToCartView,
        CartAddToCartButtonView,
        NMSProductPriceView,
        ProductModel,
        jQuery,
        _,
        nmsBuyFluShotsHomeTpl,
        nmsMainHomeTpl,
        nmsFacetsItemCellCardTpl,
        nmsFacetsItemCardActionTpl
    ) {
        'use strict';

        var installed = false;
        var storefrontApplication;
        var mainHomeProductObserver;
        var pendingHomeCleanup = false;
        var PRODUCT_SECTION_SELECTOR = [
            '.featured-products-merchzone',
            '.most-popular-products',
            '.new-products',
            '.nms-merch-container'
        ].join(', ');
        var FEATURED_SECTION_SELECTOR = '.featured-products-merchzone, .nms-merch-container';
        var NON_FEATURED_SECTION_SELECTOR = '.most-popular-products, .new-products';
        var NON_FEATURED_HOME_SELECTOR = [
            '.most-popular-products-title',
            '.most-popular-products',
            '.new-products-title',
            '.new-products'
        ].join(', ');
        var PRODUCT_TRACK_SELECTOR = '.merchandising-zone-row-template[data-type="carousel-items"]';
        var ACRONYMS = {
            EMS: true,
            FDA: true,
            IM: true,
            IV: true,
            MCG: true,
            MG: true,
            ML: true,
            NDC: true,
            OTC: true,
            PPE: true,
            SQ: true,
            USP: true
        };

        function getNMSCardImagePreset(highDensity) {
            var sizes = typeof SC !== 'undefined' && SC.ENVIRONMENT && SC.ENVIRONMENT.siteSettings && SC.ENVIRONMENT.siteSettings.imagesizes;
            var name = highDensity ? 'nmscard2x' : 'nmscard';
            var dimension = highDensity ? 800 : 400;
            var present = _.find(sizes || [], function exactCardPreset(size) {
                return size && size.name === name && Number(size.maxwidth) === dimension && Number(size.maxheight) === dimension && size.urlsuffix;
            });
            // An absent or unexpected site preset retains the incumbent image size.
            return present ? name : (highDensity ? 'zoom' : 'main');
        }

        function isBuyFluShotsSite() {
            var hostname = typeof window !== 'undefined' && window.location
                ? String(window.location.hostname || '').toLowerCase()
                : '';

            return hostname === 'buyflushots.nmsincusa.com' ||
                hostname === 'buyflu-sandbox.ethanablatt.com';
        }

        function isMainSite() {
            var hostname = typeof window !== 'undefined' && window.location
                ? String(window.location.hostname || '').toLowerCase()
                : '';

            return hostname === 'nmsincusa.com' ||
                hostname === 'www.nmsincusa.com' ||
                hostname === 'sca-sandbox.ethanablatt.com';
        }

        function isMainHomePage() {
            var pathname = typeof window !== 'undefined' && window.location
                ? String(window.location.pathname || '').replace(/^\/+|\/+$/g, '')
                : '';

            return isMainSite() && !pathname;
        }

        function isBuyFluShotsLocalPreview() {
            return isBuyFluShotsSite() &&
                /shopping-local\.ssp$/i.test(window.location.pathname);
        }

        function installSiteHome() {
            var originalGetContext;

            if (isBuyFluShotsSite()) {
                HomeView.prototype.template = nmsBuyFluShotsHomeTpl;

                if (!HomeView.prototype.nmsBuyFluShotsHeroContextInstalled) {
                    originalGetContext = HomeView.prototype.getContext;
                    HomeView.prototype.getContext = function getNMSBuyFluShotsHomeContext() {
                        var context = originalGetContext.apply(this, arguments);
                        var localPreview = isBuyFluShotsLocalPreview();

                        context.nmsBfsProductsUrl = localPreview
                            ? window.location.pathname + '#/products/flu-vaccines'
                            : '/products/flu-vaccines';
                        context.nmsBfsReimbursementUrl = localPreview
                            ? window.location.pathname + '#/flu-vaccine-reimbursement'
                            : '/flu-vaccine-reimbursement';
                        context.nmsBfsFluzoneVialUrl = localPreview
                            ? window.location.pathname + '#/FLUZONE-TIV-10-DOSE-VIAL-2026'
                            : '/FLUZONE-TIV-10-DOSE-VIAL-2026';
                        context.nmsBfsFlucelvaxPfsUrl = localPreview
                            ? window.location.pathname + '#/flucelvax-trivalent-2026-2027-prefilled-syringes-10'
                            : '/flucelvax-trivalent-2026-2027-prefilled-syringes-10';

                        if (localPreview) {
                            context.nmsBfsHeroImageUrl =
                                'http://127.0.0.1:7777/NMSDesignSystem/assets/img/' +
                                'buyflushots-hero-package-light-logo.jpg';
                        }
                        return context;
                    };
                    HomeView.prototype.nmsBuyFluShotsHeroContextInstalled = true;
                }
            } else if (isMainSite()) {
                HomeView.prototype.template = nmsMainHomeTpl;
            }
        }

        function installBuyFluShotsHeroInteraction() {
            var selector = '[data-nms-bfs-season-note]';

            jQuery(document)
                .off('.nmsBuyFluShotsHero')
                .on('pointerdown.nmsBuyFluShotsHero', selector, function pressSeasonNote(event) {
                    var pointerEvent = event.originalEvent || event;

                    if (pointerEvent.pointerType === 'mouse' && pointerEvent.button !== 0) return;
                    this.classList.add('is-pressing');
                    if (this.setPointerCapture && pointerEvent.pointerId !== undefined) {
                        this.setPointerCapture(pointerEvent.pointerId);
                    }
                })
                .on(
                    'pointerup.nmsBuyFluShotsHero pointercancel.nmsBuyFluShotsHero lostpointercapture.nmsBuyFluShotsHero',
                    selector,
                    function releaseSeasonNote() {
                        this.classList.remove('is-pressing');
                    }
                );

            jQuery(window)
                .off('blur.nmsBuyFluShotsHero')
                .on('blur.nmsBuyFluShotsHero', function releaseSeasonNoteOnBlur() {
                    jQuery(selector).removeClass('is-pressing');
                });
        }

        function getRawItemValue(model, fields) {
            var value;

            _.some(fields, function findValue(field) {
                value = model && model.get ? model.get(field) : null;
                return value !== null && value !== undefined && value !== '';
            });

            return value;
        }

        function getItemValue(model, fields) {
            var value = getRawItemValue(model, fields);

            return value === null || value === undefined || value === '' ? '—' : value;
        }

        function formatTitleCase(value, preserveAcronyms) {
            var source = String(value || '').replace(/^\s+|\s+$/g, '');

            return source.toLowerCase().replace(/[a-z0-9]+(?:['’][a-z0-9]+)*/g, function formatToken(token) {
                var upper = token.toUpperCase();

                if (preserveAcronyms && (ACRONYMS[upper] || /\d/.test(token))) {
                    return upper;
                }

                return token.charAt(0).toUpperCase() + token.slice(1);
            });
        }

        function formatCatalogLabel(value) {
            var source = String(value || '').replace(/^\s+|\s+$/g, '');

            return !source || source !== source.toUpperCase()
                ? source
                : formatTitleCase(source, true);
        }

        function getAvailabilityLabel(model) {
            return formatTitleCase(getRawItemValue(model, ['custitem_availability']));
        }

        function getAvailabilityClass(label) {
            var normalized = String(label || '').toLowerCase();

            if (normalized === 'sold out') return 'nms-product-card-availability--sold-out';
            if (normalized === 'prebooking') return 'nms-product-card-availability--prebooking';
            if (
                normalized === 'in stock - shipping today' ||
                normalized === 'available' ||
                normalized === 'available to order'
            ) {
                return 'nms-product-card-availability--available';
            }
            return '';
        }

        function getAvailabilityRank(label) {
            var normalized = String(label || '').toLowerCase();

            if (
                normalized === 'in stock - shipping today' ||
                normalized === 'available' ||
                normalized === 'available to order'
            ) return 0;
            if (normalized === 'prebooking') return 1;
            if (normalized === 'sold out') return 2;
            return 3;
        }

        function getHomeAvailabilityRank(label) {
            var normalized = String(label || '').toLowerCase();

            if (normalized === 'in stock - shipping today') return 0;
            if (normalized === 'available' || normalized === 'available to order') return 1;
            if (normalized === 'prebooking') return 2;
            if (normalized === 'sold out') return 3;
            return 4;
        }

        function isHomeProductTrack(track) {
            return jQuery(track).closest('#home-page, .home-page').length > 0;
        }

        function getMerchantView(view) {
            return view && view.parentView && view.parentView.parentView;
        }

        function getProductSection(view) {
            var merchantView = getMerchantView(view);
            var $element = view && view.$el;
            var $productSection = $element && $element.closest
                ? $element.closest(PRODUCT_SECTION_SELECTOR)
                : jQuery();

            if ($productSection.length) {
                return $productSection;
            }

            $element = merchantView && merchantView.$el;
            return $element && $element.closest
                ? $element.closest(PRODUCT_SECTION_SELECTOR)
                : jQuery();
        }

        function isProductSectionItemView(view) {
            var merchantView = getMerchantView(view);

            return !!(
                merchantView &&
                merchantView.options &&
                merchantView.options.isMerchant &&
                getProductSection(view).length
            );
        }

        function getItemUrl(model) {
            var url = model && model.get && (
                model.get('_url') ||
                model.get('urlcomponent')
            );

            if (!url) {
                return '#';
            }

            url = String(url);
            return url.charAt(0) === '/' ? url : '/' + url;
        }

        function getImageUrl(image) {
            var candidate;

            if (!image) {
                return '';
            }

            if (typeof image === 'string') {
                return image;
            }

            if (image.url) {
                return image.url;
            }

            candidate = image.urls && image.urls[0];
            return typeof candidate === 'string'
                ? candidate
                : candidate && candidate.url;
        }

        function getItemImage(model, context) {
            var imageDetails = model && model.get && model.get('itemimages_detail');
            var keyMappingImages = model && model.get && model.get('keyMapping_images');

            return getImageUrl(imageDetails && imageDetails.image) ||
                getImageUrl(imageDetails && imageDetails.main) ||
                getImageUrl(keyMappingImages && keyMappingImages[0]) ||
                (context.thumbnail && context.thumbnail.url) ||
                context.mainImage;
        }

        function keepFeaturedProductsExclusive() {
            var nonFeaturedItemIds = {};

            if (isMainHomePage()) {
                jQuery(NON_FEATURED_HOME_SELECTOR).remove();
            }

            jQuery(NON_FEATURED_SECTION_SELECTOR).find('[data-item-id]').each(function collectItemId() {
                nonFeaturedItemIds[String(jQuery(this).attr('data-item-id'))] = true;
            });

            jQuery(FEATURED_SECTION_SELECTOR).each(function filterFeaturedSection() {
                var $section = jQuery(this);

                if (
                    $section.hasClass('nms-merch-container') &&
                    $section.find('.featured-products-merchzone, ' + NON_FEATURED_SECTION_SELECTOR).length
                ) {
                    return;
                }

                $section.find('.merchandising-zone-cell-template').each(function removeNonFeaturedItem() {
                    var $cell = jQuery(this);
                    var itemId = $cell.find('[data-item-id]').first().attr('data-item-id');

                    if (itemId && nonFeaturedItemIds[String(itemId)]) {
                        $cell.remove();
                    }
                });
            });

            jQuery(PRODUCT_SECTION_SELECTOR).find(PRODUCT_TRACK_SELECTOR).each(function orderProductSection() {
                var track = this;
                var cells = jQuery(track).children('.merchandising-zone-cell-template').get();
                var getRank = isHomeProductTrack(track)
                    ? getHomeAvailabilityRank
                    : getAvailabilityRank;

                var originalCells = cells.slice();
                cells.sort(function compareAvailability(left, right) {
                    var leftLabel = jQuery(left).find('.nms-product-card-availability').first().text();
                    var rightLabel = jQuery(right).find('.nms-product-card-availability').first().text();
                    return getRank(leftLabel) - getRank(rightLabel);
                });
                if (cells.some(function movedCell(cell, index) { return cell !== originalCells[index]; })) {
                    jQuery(track).append(cells);
                }
            });
        }

        function initializeProductScroller(view) {
            var $productSection = getProductSection(view);
            var $track = view.$(PRODUCT_TRACK_SELECTOR).first();
            var $items;

            if (!$productSection.length || !$track.length || $track.data('nmsProductScrollerReady')) {
                return;
            }

            $items = $track.children('.merchandising-zone-cell-template');
            if (!$items.length) {
                return;
            }

            $productSection.addClass('nms-product-section');
            $productSection.closest('.container').first().addClass('nms-product-section-shell');
            $productSection.closest('.home-products-container').addClass('nms-featured-products-loaded');
            $track
                .data('nmsProductScrollerReady', true)
                .addClass('nms-product-section-track');
            $track.closest('.merchandising-zone-container')
                .attr('tabindex', '0')
                .attr('role', 'region')
                .attr('aria-label', 'Scroll products horizontally');

            _.defer(keepFeaturedProductsExclusive);
        }

        function installProductSectionItemView() {
            var originalChildViews = ItemRelationsRelatedItemView.prototype.childViews || {};
            var originalGetContext = ItemRelationsRelatedItemView.prototype.getContext;
            var originalRender = ItemRelationsRelatedItemView.prototype.render;
            var originalDestroy = ItemRelationsRelatedItemView.prototype.destroy;
            var NMSProductSectionAddToCartButtonView = CartAddToCartButtonView.extend({
                // SCA 26.1 binds both mouseup and click. On these cards the
                // mouseup target can be the inner label, so it does not disable
                // the button before click and the same gesture adds twice.
                events: {
                    'click [data-type="add-to-cart"]:not([disabled])': 'addToCart'
                }
            });
            var NMSProductSectionCardActionView = CartQuickAddToCartView.extend({
                template: nmsFacetsItemCardActionTpl,
                childViews: _.extend({}, CartQuickAddToCartView.prototype.childViews || {}, {
                    'AddToCart': function nmsProductSectionAddToCart() {
                        return new NMSProductSectionAddToCartButtonView({
                            model: this.model,
                            application: this.options.application || storefrontApplication
                        });
                    },
                    'NMS.Card.Price': function nmsProductSectionCardPrice() {
                        return new NMSProductPriceView({
                            model: this.model,
                            origin: 'ITEMCELL'
                        });
                    }
                }),
                getContext: function getNMSProductSectionCardActionContext() {
                    var context = CartQuickAddToCartView.prototype.getContext.apply(this, arguments);
                    var item = this.model && this.model.get && this.model.get('item');

                    context.nmsSoldOut = String(getAvailabilityLabel(item) || '').toLowerCase() === 'sold out';
                    return context;
                }
            });

            ItemRelationsRelatedItemView.prototype.getNMSProductSectionProduct = function getNMSProductSectionProduct() {
                if (!this.nmsProductSectionProduct) {
                    this.nmsProductSectionProduct = new ProductModel({
                        item: this.model,
                        quantity: this.model.get('_minimumQuantity', true) || 1
                    });
                }

                return this.nmsProductSectionProduct;
            };

            ItemRelationsRelatedItemView.prototype.childViews = _.extend({}, originalChildViews, {
                'NMS.Product.CardAction': function nmsProductSectionCardAction() {
                    return new NMSProductSectionCardActionView({
                        model: this.getNMSProductSectionProduct(),
                        application: this.options.application || storefrontApplication
                    });
                }
            });

            ItemRelationsRelatedItemView.prototype.getContext = function getNMSProductSectionItemContext() {
                var context = originalGetContext.apply(this, arguments);

                if (!isProductSectionItemView(this)) {
                    return context;
                }

                this.template = nmsFacetsItemCellCardTpl;
                context.url = getItemUrl(this.model);
                context.mainImage = getItemImage(this.model, context);
                context.nmsCardImageSize = getNMSCardImagePreset(false);
                context.nmsCardImageSize2x = getNMSCardImagePreset(true);
                context.nmsHomepageImage = true;
                context.nmsDisplayName = formatCatalogLabel(getItemValue(this.model, [
                    'storedisplayname2',
                    'displayname',
                    '_name'
                ]));
                context.nmsStrength = getItemValue(this.model, ['custitem_t3_item_strength']);
                context.nmsForm = formatCatalogLabel(getItemValue(this.model, ['custitem_t3_item_dosage_form']));
                context.nmsManufacturer = formatCatalogLabel(getItemValue(this.model, ['manufacturer']));
                context.nmsUnitSize = getItemValue(this.model, ['custitem_sip_pedigree_item_size']);
                context.nmsAvailability = getAvailabilityLabel(this.model);
                context.nmsAvailabilityClass = getAvailabilityClass(context.nmsAvailability);

                return context;
            };

            ItemRelationsRelatedItemView.prototype.render = function renderNMSProductSectionItem() {
                if (isProductSectionItemView(this)) {
                    this.template = nmsFacetsItemCellCardTpl;
                }

                return originalRender.apply(this, arguments);
            };

            ItemRelationsRelatedItemView.prototype.destroy = function destroyNMSProductSectionItem() {
                if (this.nmsProductSectionProduct) {
                    this.model.off(
                        'change',
                        this.nmsProductSectionProduct.onItemChangeUpdateLine,
                        this.nmsProductSectionProduct
                    );
                    this.nmsProductSectionProduct.off();
                    this.nmsProductSectionProduct = null;
                }

                return originalDestroy
                    ? originalDestroy.apply(this, arguments)
                    : this._destroy();
            };
        }

        function installProductSectionScrollers() {
            var originalInitSlider = MerchandisingView.prototype.initSlider;

            MerchandisingView.prototype.initSlider = function initNMSProductSectionScroller() {
                var $productTracks = jQuery(PRODUCT_SECTION_SELECTOR).find(PRODUCT_TRACK_SELECTOR);
                var result;

                if (getProductSection(this).length) {
                    initializeProductScroller(this);
                    return this;
                }

                $productTracks
                    .attr('data-nms-product-section-carousel-type', 'carousel-items')
                    .removeAttr('data-type');

                try {
                    result = originalInitSlider
                        ? originalInitSlider.apply(this, arguments)
                        : this;
                } finally {
                    $productTracks
                        .attr('data-type', 'carousel-items')
                        .removeAttr('data-nms-product-section-carousel-type');
                }

                return result;
            };
        }

        function removeStrayHeroCharacters() {
            jQuery(
                '.home-main-slider-cms-container .home-main-slider-container, ' +
                '.home-main-slider-cms-container .bx-wrapper'
            ).each(function cleanHeroSlider() {
                var slider = this;
                var candidateNodes = [slider.previousSibling, slider.nextSibling].concat(
                    Array.prototype.slice.call(slider.childNodes || [])
                );

                _.each(candidateNodes, function removeStrayCharacter(node) {
                    if (
                        node &&
                        node.nodeType === 3 &&
                        /^[<>]$/.test(jQuery.trim(node.nodeValue || ''))
                    ) {
                        node.parentNode.removeChild(node);
                    }
                });
            });
        }

        function scheduleHeroCleanup() {
            if (typeof window === 'undefined' || !window.requestAnimationFrame ||
                    typeof SC !== 'undefined' && SC.ENVIRONMENT && SC.ENVIRONMENT.jsEnvironment !== 'browser') {
                removeStrayHeroCharacters();
                keepFeaturedProductsExclusive();
                return;
            }
            if (pendingHomeCleanup) return;
            pendingHomeCleanup = true;
            window.requestAnimationFrame(function cleanNMSHomeOnce() {
                pendingHomeCleanup = false;
                if (document.querySelector(PRODUCT_SECTION_SELECTOR + ', .home-main-slider-cms-container')) {
                    removeStrayHeroCharacters();
                    keepFeaturedProductsExclusive();
                }
            });
        }

        function installMainHomeProductGuard() {
            if (
                !isMainSite() ||
                mainHomeProductObserver ||
                typeof window === 'undefined' ||
                !window.MutationObserver ||
                !document.documentElement
            ) {
                return;
            }

            mainHomeProductObserver = new window.MutationObserver(function removeLateCmsSections(mutations) {
                if (!isMainHomePage()) return;
                var relevant = mutations.some(function changedHomeSection(mutation) {
                    return Array.prototype.some.call(mutation.addedNodes, function addedHomeSection(node) {
                        return node.nodeType === 1 && (node.matches(NON_FEATURED_HOME_SELECTOR) ||
                            node.querySelector(NON_FEATURED_HOME_SELECTOR));
                    });
                });
                if (relevant) scheduleHeroCleanup();
            });
            mainHomeProductObserver.observe(document.documentElement, {
                childList: true,
                subtree: true
            });
        }

        return {
            mountToApp: function mountToApp(container) {
                var layout = container && container.getComponent
                    ? container.getComponent('Layout')
                    : null;

                storefrontApplication = container || storefrontApplication;

                if (installed) {
                    return;
                }

                installed = true;
                installSiteHome();
                installBuyFluShotsHeroInteraction();
                installProductSectionItemView();
                installProductSectionScrollers();
                installMainHomeProductGuard();
                scheduleHeroCleanup();

                if (layout) {
                    layout.on('afterShowContent', scheduleHeroCleanup);
                }
            }
        };
    }
);
